export default "__VITE_ASSET__CdZqBHht__"